import TradingOffersList from 'modules/trading/pages/TradingOffersList';
import { TradingOffersListProvider } from '../contexts/TradingOffersListContext';

const TradingOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList />
  </TradingOffersListProvider>
);

export default TradingOffersListContainer;
